import * as DistributedTaskContracts from "TFS/DistributedTask/Contracts";
import {TaskAgentHttpClient} from "TFS/DistributedTask/TaskAgentRestClient";

import {OneTimeActionCreator} from "DistributedTaskControls/Actions/OneTimeActionCreator";

import {Action} from "VSS/Flux/Action";
import {Store} from "VSS/Flux/Store";

import * as Utils_Number from "VSS/Utils/Number";
import * as Utils_String from "VSS/Utils/String";
import * as VSS from "VSS/VSS";
import Service = require("VSS/Service");
import PlatformContracts = require("VSS/Common/Contracts/Platform");
import VSSContext = require("VSS/Context");
import Platform_Contracts = require("VSS/Common/Contracts/Platform");

export interface InitializeAgentPackagesStorePayload {
    allPackages: DistributedTaskContracts.PackageMetadata[];
}
export let _initializeAgentPackagesStore = new Action<InitializeAgentPackagesStorePayload>();
export let initializeAgentPackagesStore = new OneTimeActionCreator(_initializeAgentPackagesStore);

export interface IAgentPackagesStoreOptions {
    taskAgentClient?: TaskAgentHttpClient;
}

export interface IAgentLatestPackage {
    version: string;
    package: DistributedTaskContracts.PackageMetadata;
}

export class AgentPackagesStore extends Store {
    private _latestPackagesByPlatform: IDictionaryStringTo<DistributedTaskContracts.PackageMetadata> = {};
    private _shouldIncludeRhel6Agent: boolean = false;

    constructor(options?: IAgentPackagesStoreOptions) {
        super();

        _initializeAgentPackagesStore.addListener((payload: InitializeAgentPackagesStorePayload) => {
            this._updatePackages(payload.allPackages);
        });
    }

    public getLatestPackage(platform: string): IAgentLatestPackage {
        let agentPackage: IAgentLatestPackage;

        if (this._latestPackagesByPlatform[platform]) {
            let latestPackage: DistributedTaskContracts.PackageMetadata = this._latestPackagesByPlatform[platform];
            agentPackage = {
                version: getVersion(platform), // this is only used by netcore 1.x agent
                package: latestPackage,
            };
        }

        return agentPackage;
    }
    
    public IsDotnetCoreV2Agent(): boolean {
        return true;
    }

    public ShouldIncludeRhel6Agent(): boolean {
        return this._shouldIncludeRhel6Agent;
    }

    private _setSupportedRhel6AgentState(shouldIncludeRhel6Agent: boolean) {
        this._shouldIncludeRhel6Agent = shouldIncludeRhel6Agent;
        this.emitChanged();
    }

    private _updatePackages(packages: DistributedTaskContracts.PackageMetadata[]) {
        this._latestPackagesByPlatform = {};

        let isRhel6Included: boolean = false;
        let updatedPackages = {};

        for (let agentPackage of packages) {
            if (Utils_String.equals(agentPackage.type, "agent", true)) {
                if (Utils_String.equals(agentPackage.platform, "rhel.6-x64", true)) {
                    isRhel6Included = true;
                }

                if (Utils_String.equals(agentPackage.platform, "win-x64", true) ||
                    Utils_String.equals(agentPackage.platform, "win-x86", true) ||
                    Utils_String.equals(agentPackage.platform, "osx-x64", true) ||
                    Utils_String.equals(agentPackage.platform, "linux-x64", true) ||
                    Utils_String.equals(agentPackage.platform, "linux-arm64", true) ||
                    Utils_String.equals(agentPackage.platform, "linux-arm", true) ||
                    Utils_String.equals(agentPackage.platform, "rhel.6-x64", true)) {

                    updatedPackages[agentPackage.platform] = agentPackage;
                }
            }
        }

        this._setSupportedRhel6AgentState(isRhel6Included);
        this._latestPackagesByPlatform = updatedPackages;

        this.emitChanged();
    }
}
let _store: AgentPackagesStore = null;

export function getStore(options?: IAgentPackagesStoreOptions, autoInitialize: boolean = false): AgentPackagesStore {
    if (!_store) {
        _store = new AgentPackagesStore(options);

        if (autoInitialize) {
            let progressId = VSS.globalProgressIndicator.actionStarted("AgentPackages.getStore", true);
            let distributedTaskClient = (options && options.taskAgentClient) ? options.taskAgentClient : getTaskHttpClient();

            distributedTaskClient.getPackages("agent", null, 1).then((packages: DistributedTaskContracts.PackageMetadata[]) => {
                VSS.globalProgressIndicator.actionCompleted(progressId);
                initializeAgentPackagesStore.invoke(() => {
                    return {
                        allPackages: packages
                    };
                });
            }, (err: any) => {
                VSS.handleError(err);
                VSS.globalProgressIndicator.actionCompleted(progressId);
            });
        }
    }

    return _store;
}

function getVersion(platform: string) {
    // RHEL6 is a special case because it has a period in its name
    const rhel6Prefix: string = "rhel.6";

    // eg: osx.10.11-x64, return "10.11-x64"
    return platform.toLowerCase().startsWith(rhel6Prefix) ?
        platform.slice(rhel6Prefix.length + 1, platform.length) :
        platform.slice(platform.indexOf(".") + 1, platform.length);
}

function getTaskHttpClient(): TaskAgentHttpClient {
    let webContext: PlatformContracts.WebContext = VSSContext.getDefaultWebContext();
    let vssConnection: Service.VssConnection = new Service.VssConnection(webContext, Platform_Contracts.ContextHostType.Application);
    return vssConnection.getHttpClient(TaskAgentHttpClient);
}